import * as React from "react"

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className = "", type, ...props }, ref) => {
    const hasIntentionalBackground = className.split(/\s+/).some(
      (token) => {
        const backgroundClass = token.replace(/^!/, "")
        return backgroundClass.startsWith("bg-") && !["bg-background", "bg-white", "bg-transparent"].includes(backgroundClass)
      },
    )

    return (
      <input
        type={type}
        className={`gs-modal-form-control box-border min-w-0 max-w-full flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus:outline-none focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 ${type === "date" ? "gs-modal-date-input" : ""} ${hasIntentionalBackground ? "gs-modal-autofill-preserve-bg" : ""} ${className}`}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
